/**
 * Filters 2019 functionality.
 *
 * @author Erik Jan Lam
 * @date Mar 28 2019
 */
var flyout = require('./filtersflyout');
var rangeSlider = require('./rangeslider');
var refinements = require('./refinements');
var customdropdown = require('./customdropdown');
var stickySortAndFilter = require('./stickysortandfilter');

const reInit = () => {
    App.initComponents(document.getElementById('main'));
};

// Main app object.
var App = {
    reInit: () => {
        App.initComponents(document.getElementById('main'));
    },

    init: function () {
        // flyout.
        flyout.init();
        App.initComponents();

        document.body.addEventListener('productlistingupdated', App.reInit);
    },

    initComponents: function (scope) {
        scope = scope || document;

        // refinements
        refinements.init(scope);

        // customdropdown
        if (scope.querySelector('#dropdown__selected') !== null) {
            customdropdown.init();
        }

        // range sliders.
        var sliderContainers = scope.querySelectorAll('.js-range-multiple');
        for (var i = 0; i < sliderContainers.length; i++) {
            rangeSlider(sliderContainers[i]);
        }

        stickySortAndFilter.init();
    }
};

exports.init = App.init;
